<template>
	<div
		class="wrapperitem wrapperstart wrapperend content-wrapper"
		v-if="!this.$route.params.autoitem"
	>
		<!-- teaser -->
		<article
			v-if="objectdata.contentItems"
			v-for="(item, index) in objectdata.contentItems"
			:key="index"
			class="tile-teaser tile-teaser--big"
			:class="(index % 2 == 0) ? ' tile-teaser-left' : ' tile-teaser-right'"
		>
			<figure>
				<div
					class="tile-teaser-image"
					@click="$router.push(item.linktarget)"
					:style="'background-image: url('+item.singleSRC+'); background-size: 100% 100%;'"
					
				></div>
				<!-- 
				:style="'background-image: url('+item.singleSRC+'); background-size: auto 100%;'"
				<img
					:src="item.singleSRC"
					:alt="item.title"
					:title="item.title"
					@click="$router.push(item.linktarget)"
				>-->
			</figure>
			<header>
			<!--
				<time>
					<small>{{item.timewritten}}</small>
				</time>
-->
				<h3 @click="$router.push(item.linktarget)">{{item.title}}</h3>
				<!-- <h4 v-else @click="$router.push(item.linktarget)">{{item.title}}</h4> -->
				<p v-if="item.description" v-html="item.description.substring(0,100)" />

				<a class="link" @click="$router.push(item.linktarget)">Mehr entdecken</a>
			</header>
			<!-- <a v-if="index != 0" class="btn btn-circle" @click="$router.push(item.linktarget)">
				<span>Mehr entdecken</span>
			</a>-->
		</article>
	</div>
	<div class="wrapper content-wrapper" v-else-if="this.$route.params.autoitem">
		<!-- detail -->

		<div
			class="archiv-detail"
			v-if="objectdata.contentItems"
			v-for="(item, index) in objectdata.contentItems"
			:key="index"
		>
			<div v-if="objectdata.addAutoitem == item.alias">
				<div class="ce-image">
					<figure>
						<img :src="item.singleSRC" :alt="item.title" :title="item.title" />
					</figure>
				</div>
				<div class="archiv-info">
					<!--<time>
						<small>{{item.timewritten}}</small>
					</time>-->
					<h3>{{item.title}}</h3>
					<p v-if="item.teaserDetail" v-bind:inner-html.prop="item.teaserDetail | replaceNbsp" />
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import Base from "./Base.vue";
	export default {
		extends: Base,
		props: {
			type: false,
			objectdata: {}
		},
		filters: {},
		data() {
			return {};
		},
		methods: {}
	};
	/*scripts in base.vue*/
</script>

<style lang="scss">
	@import "@/scss/variables.scss";
	@import "@/scss/mixins.scss";
	/*style in glonal-elements*/
	.archiv-detail {
		margin-top: 100px;
		@include min-screen($screen-min-m) {
			margin-top: 140px;
		}
		time {
			display: block;
			margin-bottom: 20px;
		}
	}
	.archiv-info {
		@include min-screen($screen-min-m) {
			margin: 0 50px;
		}
	}
</style>